import React from "react";
import { useSearchParams } from "react-router-dom";
import ConfirmUserButton from "../../components/ConfirmUser/ConfirmUser";

import styles from "./Confirm.module.css";

const Page = () => {
  const [searchParams] = useSearchParams();

  const userId = searchParams.get("userId") as string;
  console.log(userId);
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <a href="/" className={styles.logo}>
          <img
            src="/images/logo white.svg"
            alt="Iconic Minds"
            width={227}
            height={50}
          />
        </a>
        <h1 className={styles.heading}>Confirme sua presença</h1>
        <p className={styles.text}>
          Enviamos um email para o seu email cadastrado com um link de
          confirmação. Por favor, clique no botão abaixo para confirmar sua
          presença.
        </p>
        <p>Por favor confirme ou cancele a sua presença:</p>
        <div className={styles.buttonContainer}>
          <ConfirmUserButton confirm={true} userId={userId} type="primary" />
          <ConfirmUserButton confirm={false} userId={userId} type="secondary" />
        </div>
        <p className={styles.text}>
          Caso não tenha recebido o email, verifique sua caixa de spam ou envie
          novamente.
        </p>
        <p className={styles.text}>
          Se ainda não recebeu o email, entre em contato conosco para obter
          ajuda através de{" "}
          <a href="mailto:info@iconicminds.pt">info@iconicminds.pt</a>.
        </p>
        <p className={styles.text}>
          Obrigado por escolher o Iconic. Agradecemos por ser parte da nossa
          comunidade.
        </p>
        <p className={styles.text}>
          Atenciosamente, <br /> Equipe Iconic Minds
        </p>
        <footer>© Iconic Minds 2025</footer>
      </div>
    </div>
  );
};

export default Page;
